import useTranslation from 'next-translate/useTranslation'

import BodyText from '../../../app/components/BodyText'
import useToggleState from '../../hooks/useToggleState'

import TermsOfPurchaseModal from './TermsOfPurchaseModal'
import styles from './TermsOfPurchase.module.scss'

export default function TermsOfPurchase() {
  const { t } = useTranslation('common')

  const [isTermsModalOpen, toggleTermsModal] = useToggleState(false)

  function handleShowTerms() {
    toggleTermsModal()
  }

  return (
    <>
      <div
        className={styles.button}
        role="presentation"
        aria-label="terms of purchase"
        onClick={handleShowTerms}
      >
        <BodyText as="p">{t('termsOfPurchase.title')}</BodyText>
      </div>
      <TermsOfPurchaseModal
        isOpen={isTermsModalOpen}
        onClose={toggleTermsModal}
      />
    </>
  )
}
